export default "__VITE_ASSET__ec6903d5__"